import { rootApi } from '../../services/rootApi';
import { pageApi } from '../../utils/urls';
import { setPageData, clearPage } from './pageState';

// Page API using RTKQ with state synchronization
export const pageApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getPageById: builder.query({
      query: ({ pageId }) => ({
        url: pageApi(),
        method: 'POST',
        body: {
          data: { id: pageId },
          method: 'findById'
        },
      }),
      transformResponse: (response) => response?.data ?? null,
      providesTags: (result, error, { pageId }) => [{ type: 'Page', id: pageId }],
      async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(setPageData(data));
          }
        } catch (error) {
          console.error('Page API: Failed to fetch page', error);
          dispatch(clearPage());
        }
      },
    }),

    markPageAsViewed: builder.mutation({
      query: ({ pageId, courseId }) => ({
        url: pageApi(),
        method: 'POST',
        body: {
          data: { courseId, pageId },
          method: 'markViewed'
        },
      }),
      transformResponse: (response) => response?.data ?? null,
      // Don't invalidate page cache when marking as viewed - no need to refetch
      // invalidatesTags: (result, error, { pageId }) => [{ type: 'Page', id: pageId }],
      async onQueryStarted({ pageId, courseId }, { dispatch, queryFulfilled }) {
        // Optimistically update both Course caches so lastViewedPageId is fresh immediately
        // Update getCourseById cache (used in viewCourse - student view)
        const patchCourseById = dispatch(
          rootApi.util.updateQueryData('getCourseById', { courseId }, (draft) => {
            if (draft) draft.lastViewedPageId = pageId;
          })
        );

        // Update getCourseForBuilder cache (used in editCourse - instructor view)
        const patchCourseForBuilder = dispatch(
          rootApi.util.updateQueryData('getCourseForBuilder', { courseId }, (draft) => {
            if (draft) draft.lastViewedPageId = pageId;
          })
        );

        try {
          await queryFulfilled;
        } catch (error) {
          // Revert optimistic updates on failure
          if (patchCourseById && typeof patchCourseById.undo === 'function') {
            patchCourseById.undo();
          }
          if (patchCourseForBuilder && typeof patchCourseForBuilder.undo === 'function') {
            patchCourseForBuilder.undo();
          }
          console.error('Page API: Failed to mark page as viewed', error);
        }
      },
    }),
  }),
});

export const {
  useGetPageByIdQuery,
  useMarkPageAsViewedMutation,
} = pageApiSlice;
